import { render, staticRenderFns } from "./CatalogShow.vue?vue&type=template&id=306bbbda&scoped=true"
import script from "./CatalogShow.vue?vue&type=script&lang=js"
export * from "./CatalogShow.vue?vue&type=script&lang=js"
import style0 from "./CatalogShow.vue?vue&type=style&index=0&id=306bbbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306bbbda",
  null
  
)

export default component.exports